import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';
import ExternalLink from '../ExternalLink';
import LogoImage from './LogoImage';
import s from './Logo.module.scss';

export type LogoProps = {
  classNameModifier?: string;
  noLink?: boolean;
};

const Logo: FC<LogoProps> = ({
  classNameModifier,
  noLink = false,
}) => {
  const className = getClassName(s, 'root', classNameModifier);

  return (noLink ? (
    <span className={className}>
      <LogoImage classNameModifier={classNameModifier} />
    </span>
  ) : (
    <ExternalLink
      to="/"
      className={className}
      openInNewTab={false}
    >
      <LogoImage classNameModifier={classNameModifier} />
    </ExternalLink>
  ));
};

export default Logo;
